import { AppBar, Box, IconButton, Stack, Toolbar } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import McpHeaderAvatar from "./header-avatar";
import DevVersion from "./dev-version";
import HeaderLogo from "./header-logo";
import CajaLabel from "./caja-label";
import DepositoLabel from "./deposito-label";
import ConfigInfoChip from "@/features/facturacion-electronica/components/config-info-chip";
import { useOperationalMode } from "@/features/configuration/hooks/use-operational-mode";

interface HeaderProps {
    open: boolean,
    setOpen: (value: boolean) => void
}

export default function McpHeader({
    open,
    setOpen
}:HeaderProps){
    const { facturacionEnabled } = useOperationalMode();

    return <AppBar position="fixed" variant="outlined" elevation={0}>
        <Toolbar component={Stack} direction={"row"}alignItems={"center"} bgcolor={"background.default"} color={"text.primary"} gap={1}>
            <IconButton
                size="large" edge="start" color="inherit"
                onClick={() => setOpen(!open)}
            >
                <MenuIcon />
            </IconButton>
            <HeaderLogo/>
            <DevVersion/>
            <CajaLabel/>
            <DepositoLabel/>
            {facturacionEnabled && <ConfigInfoChip />}
            <Box sx={{ flexGrow: 1 }} />
            <McpHeaderAvatar/>
        </Toolbar>
    </AppBar>
}